import styled from 'styled-components';

import group from '../images/group.jpg';
import trail from '../images/trail.jpg';
import lecture from '../images/lecture.jpg';
import smallGroup from '../images/small_group.jpg';

const Section = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-direction: row;
  align-items: center;
  gap: 40px;

  @media (max-width: 800px) {
    margin: 0 auto;
    width: 96%;
    flex-direction: column;
    gap: 10px;
    max-width: 590px;
  }
`;

const SectionText = styled.div`
  p {
    font-size: 16px;
    line-height: 1.5;
  }

  @media (max-width: 800px) {
    order: 1;
  }
`;

const MainSectionText = styled.div`
  color: var(--black);
  p {
    font-size: 24px;
    margin: 0;
  }
  p:first-child {
    font-size: 88px;

    font-family: 'DynaPuff', system-ui;
    font-optical-sizing: auto;
    font-weight: 600;
    font-style: normal;

    color: var(--dark-orange);
  }

  @media (max-width: 1000px) {
    p {
      font-size: 24px;
    }
    p:first-child {
      font-size: 50px;
    }
  }

  @media (max-width: 800px) {
    order: 1;
    text-align: center;
    p {
      font-size: 18px;
    }
    p:first-child {
      font-size: 40px;
    }
  }
`;

const SectionTitle = styled.h1`
  display: block;
  font-size: 32px;
  margin-bottom: 32px;

  @media (max-width: 1000px) {
    font-size: 24px;
    margin-bottom: 16px;
  }

  @media (max-width: 800px) {
  }
`;

const Photo = styled.img`
  width: 49%;
  max-width: 590px;
  border-radius: 16px;
  pointer-events: none;

  @media (max-width: 800px) {
    width: 100%;
    order: 2;
  }
`;

export default function Main() {
  return (
    <>
      <Section>
        <Photo src={group} />
        <MainSectionText>
          <p>Cześć!</p>
          <p>To my - Duszpasterstwo Rodzin OP Służew.</p>
        </MainSectionText>
      </Section>
      <Section>
        <SectionText>
          <SectionTitle>Kim jesteśmy?</SectionTitle>
          <p>
            Jesteśmy rodzinami z różnych stron Warszawy, mamy dzieci od
            kilkudniowych do kilkunastoletnich. Nie jesteśmy idealni i nie
            udajemy, że kierowanie się na co dzień zasadami wiary to bułka z
            masłem. Chcemy próbować i wiemy, że razem łatwiej iść do przodu.
            Wspieramy się, dzielimy, wspólnie poszukujemy odpowiedzi na ważne
            pytania o Boga, miłość małżeńską i wychowanie dzieci.
          </p>
        </SectionText>
        <Photo src={trail} />
      </Section>
      <Section>
        <Photo src={lecture} />
        <SectionText>
          <SectionTitle>Co jest celem DROPSa?</SectionTitle>
          <p>
            Celem naszego duszpasterstwa jest odnowa i pogłębienie relacji z
            Bogiem oraz ze swoimi najbliższymi, z którymi tworzymy jeden dom,
            wynikający z sakramentu małżeństwa oraz z rodzicielstwa.
          </p>
        </SectionText>
      </Section>
      <Section>
        <SectionText>
          <SectionTitle>Jak to działa?</SectionTitle>
          <p>
            Spotykamy się co dwa tygodnie. Modlimy się, dyskutujemy, śmiejemy.
            Dwa razy do roku wyjeżdżamy na rodzinne rekolekcje. Organizujemy
            spotkania plenerowe, akcje charytatywne i spędzamy razem czas na
            wiele innych sposobów. Opiekują się nami nasi Duszpasterze – o.
            Paweł Kuś i o. Piotr Laskowski, którzy prowadzą formację duchową i
            towarzyszą nam w drodze. Bywa poważnie, bywa wesoło, jak to u
            Dominikanów.
          </p>
        </SectionText>
        <Photo src={smallGroup} />
      </Section>
    </>
  );
}
